export const BicytrustIcon = ({ size, className }) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
	>
		<g id="pen-tool-02">
			<path
				id="Icon"
				d="M13 6.00009L6.50182 7.29973C6.13883 7.37233 5.95733 7.40863 5.80952 7.4969C5.67886 7.57493 5.56772 7.68176 5.4846 7.80925C5.39057 7.95346 5.34714 8.13338 5.26028 8.49323L2 22.0001M2 22.0001L15.5069 18.7398C15.8667 18.653 16.0466 18.6095 16.1908 18.5155C16.3183 18.4324 16.4252 18.3212 16.5032 18.1906C16.5915 18.0428 16.6278 17.8613 16.7004 17.4983L18 11.0001M2 22.0001L9.586 14.4141M20.8686 7.86872L16.1314 3.13146C15.7354 2.73545 15.5373 2.53744 15.309 2.46325C15.1082 2.39799 14.8918 2.39799 14.691 2.46325C14.4627 2.53744 14.2646 2.73545 13.8686 3.13146L13.1314 3.86872C12.7354 4.26474 12.5373 4.46275 12.4632 4.69108C12.3979 4.89192 12.3979 5.10827 12.4632 5.30911C12.5373 5.53744 12.7354 5.73545 13.1314 6.13146L17.8686 10.8687C18.2646 11.2647 18.4627 11.4627 18.691 11.5369C18.8918 11.6022 19.1082 11.6022 19.309 11.5369C19.5373 11.4627 19.7354 11.2647 20.1314 10.8687L20.8686 10.1315C21.2646 9.73545 21.4627 9.53744 21.5368 9.30911C21.6021 9.10827 21.6021 8.89192 21.5368 8.69108C21.4627 8.46275 21.2646 8.26474 20.8686 7.86872ZM11 11.0001C12.1046 11.0001 13 11.8955 13 13.0001C13 14.1047 12.1046 15.0001 11 15.0001C9.89543 15.0001 9 14.1047 9 13.0001C9 11.8955 9.89543 11.0001 11 11.0001Z"
				stroke="#DDE3EE"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
	</svg>
)
